import React from 'react';
import PropTypes from 'prop-types';
import { QUESTION_TYPE } from '../../../../../../constants/shared/TrcConstants';
import { generateReactKey } from '../../../../../../utils/shared/commonUtils';

const { IMPLICIT, EXPLICIT } = QUESTION_TYPE;

const QuestionsSection = ({ oralCompResult }) => {
    const { items } = oralCompResult;
    return (
        <section className="section-block">
            {items.map(({ question, questionType, correct }, index) => (
                <div key={generateReactKey(question)} className="paragraph-holder">
                    <p className="paragraph-question">
                        {index + 1}. Recall (
                        {questionType === IMPLICIT
                            ? IMPLICIT.toLowerCase()
                            : EXPLICIT.toLowerCase()}
                        ): {question}
                    </p>
                    <span className={`indication ${correct ? 'done' : 'cancel'}`} />
                </div>
            ))}
        </section>
    );
};

QuestionsSection.defaultProps = {
    oralCompResult: { items: [] },
};

QuestionsSection.propTypes = {
    oralCompResult: PropTypes.object,
};

export default QuestionsSection;
